module.exports = __webpack_public_path__ + "static/img/btn-return.492c4b12.png";